import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "ftour__step" }
const _hoisted_3 = { class: "ftour__desc" }
const _hoisted_4 = { class: "ftour__actions" }
const _hoisted_5 = { class: "ftour__nav" }
const _hoisted_6 = ["disabled"]

import { computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useFeatureTour } from '@/composables/useFeatureTour'


export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureTourOverlay',
  setup(__props) {

const route = useRoute()
const {
  active,
  current,
  stepIndex,
  total,
  isFirst,
  isLast,
  pageTitle,
  hole,
  nextStep,
  prevStep,
  stopTour,
  refreshHole,
} = useFeatureTour()

const cardStyle = computed(() => {
  if (!hole.value.ready || typeof window === 'undefined') return {}

  const gap = 14
  const cardW = Math.min(360, window.innerWidth - 24)
  const approxH = 210
  const spaceBelow = window.innerHeight - (hole.value.top + hole.value.height)
  const placeBelow = spaceBelow > approxH + gap || hole.value.top < approxH + gap

  let top = placeBelow
    ? hole.value.top + hole.value.height + gap
    : Math.max(12, hole.value.top - approxH - gap)
  top = Math.max(12, Math.min(top, window.innerHeight - approxH - 12))

  let left = hole.value.left + hole.value.width / 2 - cardW / 2
  left = Math.max(12, Math.min(left, window.innerWidth - cardW - 12))

  return {
    top: `${top}px`,
    left: `${left}px`,
    width: `${cardW}px`,
  }
})

function onKey(event: KeyboardEvent) {
  if (!active.value) return
  if (event.key === 'Escape') stopTour()
  if (event.key === 'ArrowRight' || event.key === 'Enter') nextStep()
  if (event.key === 'ArrowLeft') prevStep()
}

/*
 * 쿼리만 바뀌는 경우(탭·필터)에는 안내를 유지한다.
 * 다른 화면(name)으로 갈 때만 닫되, 직후 검색 이동으로 새 안내를 띄울 수 있게
 * 이전 name 이 있을 때만 동작한다.
 */
watch(
  () => route.name,
  (name, prev) => {
    if (!prev || name === prev) return
    if (active.value) stopTour()
  },
)

onMounted(() => {
  window.addEventListener('resize', refreshHole)
  window.addEventListener('scroll', refreshHole, true)
  window.addEventListener('keydown', onKey)
})

onUnmounted(() => {
  window.removeEventListener('resize', refreshHole)
  window.removeEventListener('scroll', refreshHole, true)
  window.removeEventListener('keydown', onKey)
  if (active.value) stopTour()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "ftour" }, {
      default: _withCtx(() => [
        (_unref(active) && _unref(current))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ftour",
              role: "dialog",
              "aria-modal": "true",
              "aria-label": `${_unref(pageTitle)} 화면 안내`
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["ftour__catch", { 'is-solid': !_unref(hole).ready }]),
                "aria-label": "안내 닫기",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(stopTour) && _unref(stopTour)(...args)))
              }, null, 2),
              (_unref(hole).ready)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "ftour__hole",
                    style: _normalizeStyle({
            top: `${_unref(hole).top}px`,
            left: `${_unref(hole).left}px`,
            width: `${_unref(hole).width}px`,
            height: `${_unref(hole).height}px`,
          })
                  }, null, 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["ftour__card", { 'is-center': !_unref(hole).ready }]),
                style: _normalizeStyle(cardStyle.value)
              }, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(stepIndex) + 1) + " / " + _toDisplayString(_unref(total)), 1),
                _createElementVNode("h3", null, _toDisplayString(_unref(current).name), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(current).description), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "ftour__ghost",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(stopTour) && _unref(stopTour)(...args)))
                  }, "건너뛰기"),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ftour__btn",
                      disabled: _unref(isFirst),
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(prevStep) && _unref(prevStep)(...args)))
                    }, " 이전 ", 8, _hoisted_6),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ftour__btn ftour__btn--primary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(nextStep) && _unref(nextStep)(...args)))
                    }, _toDisplayString(_unref(isLast) ? '완료' : '다음'), 1)
                  ])
                ])
              ], 6)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})